import { CONFIG } from 'config/config';

import styled from 'styled-components/macro';

export const InputWrapper = styled.input`
	width: 100%;
	max-width: ${CONFIG.inputs.maxWidth.default};
	color: ${CONFIG.inputs.color};
	font-family: ${CONFIG.inputs.fontFamily};
	font-size: ${CONFIG.inputs.fontSize};
	padding: ${CONFIG.inputs.padding.default};

	border: ${(props) => {
		if (!props.value) {
			return CONFIG.inputs.border.default;
		} else {
			return CONFIG.inputs.border.filled;
		}
	}};
	border-radius: ${CONFIG.inputs.border.radius};

	::placeholder {
		color: ${CONFIG.inputs.placeholder.color};
		font-family: ${CONFIG.inputs.placeholder.fontFamily};
		font-size: ${CONFIG.inputs.placeholder.fontSize};
	}

	transition: 0.2s all;
	&:focus {
		border-bottom: ${CONFIG.inputs.focus.borderBottom.full};
	}
`;

export const SuggestOption = styled.li`
	&:focus {
		color: ${CONFIG.colors.black};
		background-color: ${CONFIG.colors.primaryLight};
		border-bottom: 4px solid ${CONFIG.colors.primary} !important;
	}
`;
